<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title> Staff members </ion-title>
    <ion-buttons slot="end">
      <ion-button
        color="primary"
        shape="default"
        fill="outline"
        *ngIf="userService.getUser().isAdministrator()"
        (click)="addStaffMember()"
      >
        <ion-icon name="add"></ion-icon> New
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" #content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylists"
    (click)="loadStaff()"
  ></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStylists">
    <ion-item-divider> Active staff</ion-item-divider>
    <ion-reorder-group
      [disabled]="false"
      (ionItemReorder)="handleReorder($any($event))"
    >
      <ion-item
        class="stylist-card-container"
        lines="none"
        *ngFor="let stylist of activeStylists"
        tappable
      >
        <div
          class="ion-padding stylist-card"
          (click)="onStylistSelect(stylist)"
        >
          <div class="ion-padding profile-pic-container">
            <ion-avatar class="profile-pic">
              <img
                [defaultImage]="defaultStylistPhoto"
                [lazyLoad]="stylist.getFullThumbnailUrl()"
                [errorImage]="defaultStylistPhoto"
              />
            </ion-avatar>
          </div>
          <div class="stylist-info">
            <div class="ion-padding stylist-detail-container">
              <div class="stylist-detail-name" lines="none">
                {{ stylist.getFirstName() }} {{ stylist.getLastName() }}
              </div>
            </div>
            <div class="ion-padding stylist-detail-phone-container">
              <div class="stylist-detail">{{ stylist.phone2 }}</div>
            </div>
            <div class="ion-padding stylist-detail-container">
              <div *ngIf="stylist.isAdministrator()" class="role role-admin">
                <span class="long-role"> Administrator </span>
                <span class="short-role"> Admin </span>
              </div>
              <div *ngIf="stylist.calendar == 1" class="role role-status">
                <span class="long-role"> Scheduling </span>
                <span class="short-role"> Sched </span>
              </div>
            </div>
            <div class="ion-padding stylist-address-container">
              <div class="stylist-detail">{{ stylist.address1 }}</div>
            </div>
          </div>
        </div>

        <ion-reorder slot="end"></ion-reorder>
      </ion-item>
    </ion-reorder-group>

    <ion-item-divider> Inactive staff</ion-item-divider>
    <ion-list>
      <ion-item
        class="stylist-card-container"
        lines="none"
        *ngFor="let stylist of inActiveStylists"
        tappable
      >
        <div
          class="ion-padding stylist-card"
          (click)="onStylistSelect(stylist)"
        >
          <div class="ion-padding profile-pic-container">
            <ion-avatar class="profile-pic">
              <img
                [defaultImage]="defaultStylistPhoto"
                [lazyLoad]="stylist.getFullThumbnailUrl()"
                [errorImage]="defaultStylistPhoto"
              />
            </ion-avatar>
          </div>
          <div class="stylist-info">
            <div class="ion-padding stylist-detail-container">
              <div class="stylist-detail-name" lines="none">
                {{ stylist.getFirstName() }} {{ stylist.getLastName() }}
              </div>
            </div>
            <div class="ion-padding stylist-detail-phone-container">
              <div class="stylist-detail">{{ stylist.phone2 }}</div>
            </div>
            <div class="ion-padding stylist-detail-container">
              <div *ngIf="stylist.isAdministrator()" class="role role-admin">
                <span class="long-role"> Administrator </span>
                <span class="short-role"> Admin </span>
              </div>
              <div *ngIf="stylist.calendar == 1" class="role role-status">
                <span class="long-role"> Scheduling </span>
                <span class="short-role"> Sched </span>
              </div>
            </div>
            <div class="ion-padding stylist-address-container">
              <div class="stylist-detail">{{ stylist.address1 }}</div>
            </div>
          </div>
        </div>
      </ion-item>
    </ion-list>
  </ng-container>
</ion-content>
